import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { translate } from '@jsverse/transloco';
import { AppNotificationService } from 'src/app/shared/services/notification.service';
import { ICompany, IUpdateCompanySettingsRequest } from '../models/company';
import { CompanyService } from '../services/company.service';

/**
 * Module settings of a company (HTEC only). Built as a small settings form so further
 * tenant settings can be added as additional controls later on.
 */
@Component({
    selector: 'app-company-settings',
    templateUrl: './company-settings.component.html',
    styleUrl: './company-settings.component.scss',
    standalone: false
})
export class CompanySettingsComponent implements OnInit {
  @Input() company: ICompany;

  form: UntypedFormGroup;
  saving = false;

  constructor(
    private companyService: CompanyService,
    private appNotificationService: AppNotificationService
  ) { }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      inventoryEnabled: new UntypedFormControl(this.company?.inventoryEnabled === true)
    });
  }

  get isInventoryEnabled(): boolean {
    return this.form.get('inventoryEnabled').value === true;
  }

  toggleInventoryEnabled(): void {
    const control = this.form.get('inventoryEnabled');
    control.setValue(!this.isInventoryEnabled);
    control.markAsDirty();
    this.form.markAsDirty();
  }

  onSubmit(): void {
    const request: IUpdateCompanySettingsRequest = {
      id: this.company.id,
      inventoryEnabled: this.form.value.inventoryEnabled === true
    };

    this.saving = true;
    this.companyService.updateCompanySettings(request).subscribe({
      next: (settings) => {
        this.company.inventoryEnabled = settings.inventoryEnabled;
        this.form.patchValue({ inventoryEnabled: settings.inventoryEnabled });
        this.form.markAsPristine();
        this.saving = false;
        this.appNotificationService.notification$.next({ message: translate('companies.settings.updateSuccess'), style: "success" });
      },
      error: () => {
        this.saving = false;
      }
    });
  }
}